// Names live ONLY inside ROUNDS entries below. The roster on the site
// is built from unique player names across all rounds — never store a
// name anywhere else.
//
// Each player entry in a round:
//   dots  = total dots off the scorecard
//   parIn = true if he parred in on holes 15-18, or the actual dollar
//           amount handed to him for Par In (e.g. parIn: 42) when the
//           table split differs from the calculated share
//   leg   = "rabbit" | "squirrel" | null
//   Exactly ONE Rabbit winner and ONE different Squirrel winner per
//   round — no player can win both. Rabbit collects $5 from every
//   other player; Squirrel collects $2. Everyone else null.
//
// Optional round-level fields:
//   photo = image path shown on that round's card, e.g.
//           photo: "/images/round-2026-08-29.jpg"
//           (files live in /public/images)
//   headline = optional standout-payout line shown above the round's
//           results table. Leave it out and the space stays empty.
//   teamBet = optional line about the team bet, shown just below the
//           headline in smaller, lighter text. Leave it out and the
//           space stays empty.
//   carryPar = optional. Set to false when an unclaimed Par In pot is
//           handed back to the field ($5 each) instead of carrying to
//           the next round. Leave it out for the normal carryover.
//
// Optional player-level field:
//   paid  = the GROSS dollar amount actually handed to the player in
//           the clubhouse, before the buy-in (e.g. paid: 138). When
//           present, it replaces the site's calculation and NET shows
//           paid minus the $35 buy-in. Year-to-date sums whatever is
//           displayed, so season totals always match what was paid.
//           The payout check always runs the true unrounded math, so
//           overrides never flag a mismatch.

export const ROUNDS = [
  {
    date: "2026-08-29",
    day: "Saturday",
    photo: "/images/round-2026-08-29.jpg",
    headline: "Fred Longoria parred in alone and walked off with all $95. Nobody else could finish.",
    players: [
      // dots  = total dots off the scorecard
      // parIn = true if he parred in on 15-18
      // leg   = "rabbit" | "squirrel" | null
      // paid  = gross handed out at the table, before the $35 buy-in
      { name: "Jeremiah Tongkhoyam", dots: 7, parIn: false, leg: null, paid: 110 },
      { name: "Martin Bajala",       dots: 5, parIn: false, leg: null, paid: 79 },
      { name: "Noom Tunsatian",      dots: 5, parIn: false, leg: null, paid: 79 },
      { name: "Jeff Robinson",       dots: 4, parIn: false, leg: null, paid: 63 },
      { name: "Joe Lopez",           dots: 3, parIn: false, leg: null, paid: 47 },
      { name: "Fred Longoria",       dots: 2, parIn: 95,  leg: null, paid: 126 },
      { name: "Alex Hall",           dots: 2, parIn: false, leg: null, paid: 31 },
      { name: "Scott Lewis",         dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Jose Cruz",           dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Nick Sivil",          dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Ed Hascup",           dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Barry Borrilez",      dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Garrett Walker",      dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Ric Buesgen",         dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Ian Hall",            dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Reggie Jones",        dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Bijon Hughes",        dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Ron Cappel",          dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Troy Ham",            dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-08-30",
    day: "Sunday",
    photo: "/images/hero.jpg",
    headline: "Tony Amaral caught the Rabbit and collected $5 from all 14 of you. $70 for one hole.",
    teamBet: "Sunday's team bet came down to the wire. And the winner is... nobody. We tied.",
    players: [
      { name: "Barry Borrilez",   dots: 7, parIn: false, leg: null,     paid: 70 },
      { name: "Scott Lewis",      dots: 5, parIn: false, leg: null,     paid: 47 },
      { name: "Marc Sillanpaa",   dots: 5, parIn: false, leg: null,     paid: 47 },
      { name: "Martin Bajala",    dots: 4, parIn: false, leg: null,     paid: 36 },
      { name: "Will Wartick",     dots: 4, parIn: false, leg: null,     paid: 36 },
      { name: "Javier Hernandez", dots: 4, parIn: false, leg: null,     paid: 36 },
      { name: "Tony Amaral",      dots: 3, parIn: 38,  leg: "rabbit", paid: 139 },
      { name: "Nick Sivil",       dots: 3, parIn: false, leg: null,     paid: 27 },
      { name: "Troy Ham",         dots: 3, parIn: false, leg: null,     paid: 27 },
      { name: "Jose Cruz",        dots: 2, parIn: false, leg: null,     paid: 16 },
      { name: "Ed Hascup",        dots: 1, parIn: false, leg: null,     paid: 5 },
      { name: "Chuck Kahuli",     dots: 1, parIn: false, leg: null,     paid: 5 },
      { name: "Jamie Haneca",     dots: 1, parIn: false, leg: null,     paid: 5 },
      { name: "Garrett Walker",   dots: 0, parIn: 37,  leg: null,     paid: 32 },
      { name: "Ron Cappel",       dots: 0, parIn: false, leg: null,     paid: -5 },
    ]
  },
  {
    date: "2026-09-05",
    day: "Saturday",
    photo: "/images/round-2026-09-05.jpg",
    headline: "Nobody could par in, so everybody got their five back. Noom Tunsatian led the day with 4 dots and $108.",
    carryPar: false,
    players: [
      { name: "Noom Tunsatian",      dots: 4, parIn: false, leg: null, paid: 108 },
      { name: "Scott Lewis",         dots: 3, parIn: false, leg: null, paid: 81 },
      { name: "Joe Lopez",           dots: 3, parIn: false, leg: null, paid: 81 },
      { name: "Nick Sivil",          dots: 2, parIn: false, leg: null, paid: 54 },
      { name: "Jose Cruz",           dots: 2, parIn: false, leg: null, paid: 54 },
      { name: "Will Wartick",        dots: 2, parIn: false, leg: null, paid: 54 },
      { name: "Bijon Hughes",        dots: 1, parIn: false, leg: null, paid: 27 },
      { name: "Ed Hascup",           dots: 1, parIn: false, leg: null, paid: 27 },
      { name: "Fred Longoria",       dots: 1, parIn: false, leg: null, paid: 27 },
      { name: "Ron Cappel",          dots: 1, parIn: false, leg: null, paid: 27 },
      { name: "Barry Borrilez",      dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Reggie Jones",        dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Jamie Haneca",        dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Sam Thomas",          dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Brian Brewer",        dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Ric Buesgen",         dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Jeremy Ducharme",     dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Martin Bajala",       dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-09-06",
    day: "Sunday",
    photo: "/images/green.jpg",
    headline: "Scott Lewis parred in, caught the Rabbit, and put up 4 dots. $173 in one afternoon.",
    players: [
      { name: "Jamie Haneca",        dots: 6, parIn: false, leg: null,     paid: 76 },
      { name: "Sam Thomas",          dots: 6, parIn: false, leg: null,     paid: 76 },
      { name: "Javier Hernandez",    dots: 5, parIn: false, leg: null,     paid: 64 },
      { name: "Scott Lewis",         dots: 4, parIn: 42,  leg: "rabbit", paid: 173 },
      { name: "Barry Borrilez",      dots: 2, parIn: false, leg: null,     paid: 25 },
      { name: "Fred Longoria",       dots: 3, parIn: false, leg: null,     paid: 38 },
      { name: "Marc Sillanpaa",      dots: 3, parIn: false, leg: null,     paid: 38 },
      { name: "Jose Cruz",           dots: 2, parIn: false, leg: null,     paid: 25 },
      { name: "Dylan McIntyre",      dots: 2, parIn: false, leg: null,     paid: 25 },
      { name: "Jeremiah Tongkhoyam", dots: 3, parIn: false, leg: null,     paid: 38 },
      { name: "Tony Amaral",         dots: 1, parIn: 42,  leg: null,     paid: 55 },
      { name: "Nick Sivil",          dots: 1, parIn: false, leg: null,     paid: 13 },
      { name: "Martin Bajala",       dots: 1, parIn: false, leg: null,     paid: 13 },
      { name: "Ed Hascup",           dots: 1, parIn: false, leg: null,     paid: 13 },
      { name: "Chuck Kahuli",        dots: 0, parIn: false, leg: null,     paid: 0 },
      { name: "Reggie Jones",        dots: 0, parIn: false, leg: null,     paid: 0 },
      { name: "Jeremy Ducharme",     dots: 0, parIn: false, leg: null,     paid: 0 },
    ]
  },
  {
    date: "2026-09-12",
    day: "Saturday",
    headline: "Nick Sivil was the only man standing on the par in and took the whole $50. Six dots on top of it.",
    players: [
      { name: "Nick Sivil",     dots: 6, parIn: 50,  leg: null, paid: 112 },
      { name: "Jeff Robinson",  dots: 6, parIn: false, leg: null, paid: 62 },
      { name: "Justin ______",  dots: 4, parIn: false, leg: null, paid: 41 },
      { name: "Jose Cruz",      dots: 4, parIn: false, leg: null, paid: 41 },
      { name: "Ron Cappel",     dots: 3, parIn: false, leg: null, paid: 31 },
      { name: "Reggie Jones",   dots: 2, parIn: false, leg: null, paid: 21 },
      { name: "Scott Lewis",    dots: 2, parIn: false, leg: null, paid: 21 },
      { name: "Joe Lopez",      dots: 1, parIn: false, leg: null, paid: 10 },
      { name: "Ed Hascup",      dots: 1, parIn: false, leg: null, paid: 10 },
      { name: "Noom Tunsatian", dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-09-13",
    day: "Sunday",
    headline: "Dylan McIntyre parred in and caught the Rabbit. $153 and everybody else reaching for their wallet.",
    // Rabbit: Dylan's $70 is already inside his paid: 153. The other 14
    // paid their $5 separately, so each of their paid values is $5 lower
    // than what was handed out at the table.
    players: [
      { name: "Marc Sillanpaa",  dots: 7, parIn: false, leg: null,     paid: 76 },
      { name: "Tom Jackson",     dots: 6, parIn: 25,  leg: null,     paid: 89 },
      { name: "Dylan McIntyre",  dots: 5, parIn: 25,  leg: "rabbit", paid: 153 },
      { name: "Martin Bajala",   dots: 5, parIn: false, leg: null,     paid: 53 },
      { name: "Scott Lewis",     dots: 4, parIn: false, leg: null,     paid: 41 },
      { name: "Kurt Crigger",    dots: 2, parIn: false, leg: null,     paid: 18 },
      { name: "Tony Amaral",     dots: 2, parIn: false, leg: null,     paid: 18 },
      { name: "Jamie Haneca",    dots: 2, parIn: false, leg: null,     paid: 18 },
      { name: "Jose Cruz",       dots: 2, parIn: false, leg: null,     paid: 18 },
      { name: "Nick Sivil",      dots: 1, parIn: 25,  leg: null,     paid: 32 },
      { name: "Ed Hascup",       dots: 1, parIn: false, leg: null,     paid: 7 },
      { name: "Nelson Prouty",   dots: 1, parIn: false, leg: null,     paid: 7 },
      { name: "Arvin Persaud",   dots: 1, parIn: false, leg: null,     paid: 7 },
      { name: "Fred Longoria",   dots: 0, parIn: false, leg: null,     paid: -5 },
      { name: "Chuck Kahuli",    dots: 0, parIn: false, leg: null,     paid: -5 },
    ]
  },
  {
    date: "2026-09-19",
    day: "Saturday",
    photo: "/images/round-2026-09-19.jpg",
    headline: "Jamie Haneca led the field with 6 dots and walked off with $80. Six guys parred in on a big 21 man Saturday.",
    // Par In was rounded down to $15 each at the table ($719 paid on a
    // $735 pot) — intentional, covered by the rounding note.
    players: [
      { name: "Jamie Haneca",        dots: 6, parIn: false, leg: null, paid: 80 },
      { name: "Jeff Robinson",       dots: 5, parIn: 15,  leg: null, paid: 82 },
      { name: "Javier Hernandez",    dots: 4, parIn: 15,  leg: null, paid: 69 },
      { name: "Marc Sillanpaa",      dots: 4, parIn: false, leg: null, paid: 54 },
      { name: "Jeremiah Tongkhoyam", dots: 3, parIn: 15,  leg: null, paid: 55 },
      { name: "Noom Tunsatian",      dots: 3, parIn: false, leg: null, paid: 40 },
      { name: "Scott Lewis",         dots: 3, parIn: false, leg: null, paid: 40 },
      { name: "Jose Cruz",           dots: 3, parIn: false, leg: null, paid: 40 },
      { name: "Joe Lopez",           dots: 3, parIn: false, leg: null, paid: 40 },
      { name: "Dylan McIntyre",      dots: 2, parIn: 15,  leg: null, paid: 42 },
      { name: "Garrett Walker",      dots: 2, parIn: false, leg: null, paid: 27 },
      { name: "Reggie Jones",        dots: 2, parIn: false, leg: null, paid: 27 },
      { name: "Ed Hascup",           dots: 2, parIn: false, leg: null, paid: 27 },
      { name: "Barry Borrilez",      dots: 2, parIn: false, leg: null, paid: 27 },
      { name: "Nick Sivil",          dots: 1, parIn: 15,  leg: null, paid: 28 },
      { name: "Kurt Crigger",        dots: 1, parIn: false, leg: null, paid: 13 },
      { name: "Sam Thomas",          dots: 1, parIn: false, leg: null, paid: 13 },
      { name: "Martin Bajala",       dots: 0, parIn: 15,  leg: null, paid: 15 },
      { name: "Ron Cappel",          dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Jeremy Ducharme",     dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Fred Brown",          dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-09-26",
    day: "Saturday",
    headline: "Arvin Persaud topped the card with 7 dots. Chase Hascup showed up for his first round, put 6 on the board and parred in.",
    players: [
      { name: "Arvin Persaud",   dots: 7, parIn: false, leg: null, paid: 68 },
      { name: "Chase Hascup",    dots: 6, parIn: true,  leg: null, paid: 92 },
      { name: "Nick Sivil",      dots: 6, parIn: false, leg: null, paid: 58 },
      { name: "Garrett Walker",  dots: 5, parIn: true,  leg: null, paid: 82 },
      { name: "Joe Lopez",       dots: 5, parIn: false, leg: null, paid: 49 },
      { name: "Mick",            dots: 2, parIn: false, leg: null, paid: 19 },
      { name: "Joe S",           dots: 2, parIn: false, leg: null, paid: 19 },
      { name: "Ric Buesgen",     dots: 2, parIn: false, leg: null, paid: 19 },
      { name: "Ron Cappel",      dots: 2, parIn: false, leg: null, paid: 19 },
      { name: "Barry Borrilez",  dots: 1, parIn: false, leg: null, paid: 10 },
      { name: "Ed Hascup",       dots: 1, parIn: false, leg: null, paid: 10 },
      { name: "Reggie Jones",    dots: 1, parIn: false, leg: null, paid: 10 },
      { name: "Jeremy Ducharme", dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-09-27",
    day: "Sunday",
    headline: "Garrett Walker went for 7 dots and $114 on a short twelve man Sunday.",
    players: [
      { name: "Garrett Walker",    dots: 7, parIn: false, leg: null, paid: 114 },
      { name: "Jeff Robinson",     dots: 3, parIn: false, leg: null, paid: 49 },
      { name: "Nick Sivil",        dots: 3, parIn: false, leg: null, paid: 49 },
      { name: "Javier Hernandez",  dots: 2, parIn: true,  leg: null, paid: 93 },
      { name: "Kurt Crigger",      dots: 2, parIn: false, leg: null, paid: 33 },
      { name: "Ed Hascup",         dots: 2, parIn: false, leg: null, paid: 33 },
      { name: "Tony Amaral",       dots: 2, parIn: false, leg: null, paid: 33 },
      { name: "Ron Cappel",        dots: 1, parIn: false, leg: null, paid: 16 },
      { name: "Ric Buesgen",       dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Jeremy Ducharme",   dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Jose Cruz",         dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Michael",           dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-10-04",
    day: "Sunday",
    headline: "Three guys parred in and split the pot. Jamie Haneca led the day with 5 dots and $105.",
    players: [
      { name: "Jamie Haneca",      dots: 5, parIn: true,  leg: null, paid: 105 },
      { name: "Tony Amaral",       dots: 4, parIn: true,  leg: null, paid: 90 },
      { name: "Javier Hernandez",  dots: 4, parIn: true,  leg: null, paid: 90 },
      { name: "Jose Cruz",         dots: 3, parIn: false, leg: null, paid: 45 },
      { name: "Marc Sillanpaa",    dots: 3, parIn: false, leg: null, paid: 45 },
      { name: "Greg",              dots: 3, parIn: false, leg: null, paid: 45 },
      { name: "Barry Borrilez",    dots: 2, parIn: false, leg: null, paid: 30 },
      { name: "Martin Bajala",     dots: 2, parIn: false, leg: null, paid: 30 },
      { name: "Jeff Robinson",     dots: 2, parIn: false, leg: null, paid: 30 },
      { name: "Troy Ham",          dots: 2, parIn: false, leg: null, paid: 30 },
      { name: "Nick Sivil",        dots: 2, parIn: false, leg: null, paid: 30 },
      { name: "Garrett Walker",    dots: 1, parIn: false, leg: null, paid: 15 },
      { name: "Jeremy Ducharme",   dots: 1, parIn: false, leg: null, paid: 15 },
      { name: "Kurt Crigger",      dots: 1, parIn: false, leg: null, paid: 15 },
      { name: "Ron Cappel",        dots: 1, parIn: false, leg: null, paid: 15 },
      { name: "Reggie Jones",      dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Clint Birch",       dots: 0, parIn: false, leg: null, paid: 0 },
      { name: "Ed Hascup",         dots: 0, parIn: false, leg: null, paid: 0 },
    ]
  },
  {
    date: "2026-10-25",
    day: "Sunday",
    headline: "Jeremiah Tongkhoyam had the round of the year. Six dots, parred in, and caught the Rabbit. $243 on a Sunday.",
    // Rabbit: Jeremiah's $105 is already inside his paid: 243. The other
    // 21 paid their $5 separately, so each of their paid values is $5
    // lower than what was handed out at the table.
    players: [
      { name: "Jeremiah Tongkhoyam", dots: 6, parIn: 36,  leg: "rabbit", paid: 243 },
      { name: "Joe Lopez",           dots: 6, parIn: false, leg: null,     paid: 97 },
      { name: "Garrett Walker",      dots: 4, parIn: false, leg: null,     paid: 63 },
      { name: "Tony Amaral",         dots: 3, parIn: false, leg: null,     paid: 46 },
      { name: "Reggie Jones",        dots: 3, parIn: false, leg: null,     paid: 46 },
      { name: "Alex Hall",           dots: 2, parIn: 36,  leg: null,     paid: 65 },
      { name: "Kurt Crigger",        dots: 2, parIn: false, leg: null,     paid: 29 },
      { name: "Will Wartick",        dots: 2, parIn: false, leg: null,     paid: 29 },
      { name: "Ed Hascup",           dots: 2, parIn: false, leg: null,     paid: 29 },
      { name: "Ron Cappel",          dots: 2, parIn: false, leg: null,     paid: 29 },
      { name: "Troy Ham",            dots: 2, parIn: false, leg: null,     paid: 29 },
      { name: "Nick Sivil",          dots: 1, parIn: false, leg: null,     paid: 12 },
      { name: "Jose Cruz",           dots: 1, parIn: false, leg: null,     paid: 12 },
      { name: "Marc Sillanpaa",      dots: 1, parIn: false, leg: null,     paid: 12 },
      { name: "Nelson Prouty",       dots: 1, parIn: false, leg: null,     paid: 12 },
      { name: "Brian Brewer",        dots: 1, parIn: false, leg: null,     paid: 12 },
      { name: "Fred Longoria",       dots: 0, parIn: 36,  leg: null,     paid: 31 },
      { name: "Arvin Persaud",       dots: 0, parIn: false, leg: null,     paid: -5 },
      { name: "Ric Buesgen",         dots: 0, parIn: false, leg: null,     paid: -5 },
      { name: "Chuck Kahuli",        dots: 0, parIn: false, leg: null,     paid: -5 },
      { name: "Ian Hall",            dots: 0, parIn: false, leg: null,     paid: -5 },
      { name: "Jeremy Ducharme",     dots: 0, parIn: false, leg: null,     paid: -5 },
    ]
  },
  // paste each new round here, newest at the bottom
];
